import { render, staticRenderFns } from "./highSetting.vue?vue&type=template&id=375f8300&scoped=true&"
import script from "./highSetting.vue?vue&type=script&lang=js&"
export * from "./highSetting.vue?vue&type=script&lang=js&"
import style0 from "./highSetting.vue?vue&type=style&index=0&id=375f8300&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375f8300",
  null
  
)

export default component.exports